import { Directive, ViewContainerRef } from '@angular/core';

@Directive({
  selector: '[languageDetailDirective]',
})
export class LanguageDetailDirective {
  constructor(public viewContainerRef: ViewContainerRef) { }
}